<template>
  <div :id="id"
       class="o-echarts">

  </div>
</template>

<script>
// import echarts from 'echarts'
import * as echarts from 'echarts'
import moment from 'moment'
let chart = null
const labelOption = {
  // show: true,
  position: 'insideBottom',
  distance: 15,
  align: 'left',
  verticalAlign: 'middle',
  // rotate: 90,
  // formatter: '{b}  {name|{a}}',
  fontSize: 16,
  rich: {
    name: {}
  }
}
export default {
  name: 'ProvinceInsuredChart',
  props: {
    id: {
      type: String,
      required: false,
      default: 'chart'
    },
    subtext: {
      type: String,
      required: false,
      default: moment().format('YYYY年MM月DD日')
    }
  },
  data () {
    return {
      // id: 'provinceInsuredChart',//地图渲染容器id
      option: {
        title: {
          text: '',
          subtext: '(2020年5月6日)',
          left: 'right'
        },
        tooltip: {
          trigger: 'axis'
          // axisPointer: {
          //   type: 'shadow'
          // }
        },
        dataset: {
          // dimensions: ['insurance', '水稻政策保险', '大豆政策保险', '玉米政策保险'],
          // source: [
          //   { insurance: '2011', '水稻政策保险': 1000, '大豆政策保险': 1500, '玉米政策保险': 1200},
          //   { insurance: '2012', '水稻政策保险': 2000, '大豆政策保险': 1800, '玉米政策保险': 1600 },
          //   { insurance: '2013', '水稻政策保险': 5000, '大豆政策保险': 2000, '玉米政策保险': 3000},
          //   { insurance: '2014', '水稻政策保险': 10000, '大豆政策保险': 5000, '玉米政策保险': 8000 }
          // ]
        },
        legend: {
          // data: ['大豆政策性保险', '小麦政策性保险', '水稻政策性保险', '玉米政策性保险']
        },
        toolbox: {
          show: true,
          orient: 'vertical',
          left: 'right',
          top: 'center'
          // feature: {
          //   mark: { show: true },
          //   dataView: { show: true, readOnly: false },
          //   magicType: { show: true, type: ['line', 'bar', 'stack'] },
          //   restore: { show: true },
          //   saveAsImage: { show: true }
          // }
        },
        xAxis: [
          {
            type: 'category',
            axisTick: { show: false }
            // data: ['2012', '2013', '2014', '2015', '2016']
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              color: '#333',
              fontSize: 16,
              formatter: function (value, index) {
                if (value === 0) {
                  return value
                } else if (value >= 10000) {
                  return value / 10000 + '万亩'
                } else {
                  return value + '亩'
                }
              }
            }
          }
        ],
        color: ['#3e66e2', '#4ab2e9', '#12d5d3', '#ff9023'],
        series: [
          {
            name: '大豆政策性保险',
            type: 'bar',
            barMaxWidth: 20,
            barMinWidth: 14,
            barWidth: 20,
            barGap: 0.2,
            label: labelOption,
            emphasis: {
              focus: 'series'
            }
            // data: [220, 182, 191, 234, 290, 330, 310, 182, 191, 234]
          },
          {
            name: '小麦政策性保险',
            type: 'bar',
            barMaxWidth: 20,
            barMinWidth: 14,
            barWidth: 20,
            barGap: 0.2,
            label: labelOption,
            emphasis: {
              focus: 'series'
            }
            // data: [220, 182, 191, 234, 290]
          },
          {
            name: '水稻政策性保险',
            type: 'bar',
            barMaxWidth: 20,
            barMinWidth: 14,
            barWidth: 20,
            barGap: 0.2,
            label: labelOption,
            emphasis: {
              focus: 'series'
            }
            // data: [150, 232, 201, 154, 190]
          },
          {
            name: '玉米政策性保险',
            type: 'bar',
            barMaxWidth: 20,
            barMinWidth: 14,
            barWidth: 20,
            barGap: 0.2,
            label: labelOption,
            emphasis: {
              focus: 'series'
            }
            // data: [98, 77, 101, 99, 40]
          }
        ]
      }

      // option: {
      //   title: {
      //     text: '',
      //     subtext: '(2020年5月6日)',
      //     left: 'right'
      //   },
      //   tooltip: {
      //     trigger: 'axis',
      //     axisPointer: {
      //       type: 'cross',
      //       label: {
      //         backgroundColor: '#6a7985'
      //       }
      //     }
      //   },
      //   dataset: {
      //     // dimensions: ['insurance', '水稻政策保险', '大豆政策保险', '玉米政策保险'],
      //     // source: [
      //     //   { insurance: '2011年', '水稻政策保险': 1000, '大豆政策保险': 1500, '玉米政策保险': 1200},
      //     //   { insurance: '2012年', '水稻政策保险': 2000, '大豆政策保险': 1800, '玉米政策保险': 1600 },
      //     //   { insurance: '2013年', '水稻政策保险': 5000, '大豆政策保险': 2000, '玉米政策保险': 3000},
      //     //   { insurance: '2014年', '水稻政策保险': 10000, '大豆政策保险': 5000, '玉米政策保险': 8000 },
      //     // ]
      //   },
      //   legend: {
      //     top: '',
      //     itemGap: 20,
      //     itemWidth: 10,
      //     itemHeight: 10,
      //     textStyle: {
      //       color: '#333'
      //     },
      //     icon: 'rect'
      //     // data: ["水稻政策保险", "大豆政策保险", "玉米政策保险"]
      //   },
      //   toolbox: {

      //   },
      //   grid: {
      //     left: '3%',
      //     right: '4%',
      //     bottom: '3%',
      //     containLabel: true
      //   },
      //   xAxis: [
      //     {
      //       type: 'category',
      //       boundaryGap: false
      //       // data: [
      //       //   "2011年",
      //       //   "2012年",
      //       //   "2013年",
      //       //   "2014年",
      //       //   "2015年",
      //       //   "2016年",
      //       //   "2017年",
      //       //   "2018年",
      //       //   "2019年",
      //       //   "2020年"
      //       // ]
      //     }
      //   ],
      //   yAxis: {
      //     axisTick: {
      //       show: false
      //     },
      //     splitLine: {
      //       lineStyle: {
      //         type: 'dotted'
      //       }
      //     },
      //     axisLine: {
      //       show: false
      //     },
      //     axisLabel: {
      //       color: '#333',
      //       fontSize: 16,
      //       formatter: function (value, index) {
      //         if (value === 0) {
      //           return value
      //         } else if (value >= 10000) {
      //           return value / 10000 + '万亩'
      //         } else {
      //           return value + '亩'
      //         }
      //       }
      //     }
      //   },
      //   color: ['#3e66e2', '#4ab2e9', '#12d5d3', '#ff9023'],
      //   series: [
      //     {
      //       // name: "水稻政策保险",
      //       // data: [120, 132, 101, 134, 90, 230, 210, 134, 90, 230],
      //       type: 'line',
      //       smooth: true,
      //       stack: '总量',
      //       itemStyle: {
      //         // opacity: 0
      //       },
      //       areaStyle: {
      //         color: {
      //           type: 'linear',
      //           x: 0,
      //           y: 0,
      //           x2: 0,
      //           y2: 1,
      //           colorStops: [
      //             {
      //               offset: 0,
      //               color: '#3e66e2' // 0% 处的颜色
      //             },
      //             {
      //               offset: 1,
      //               color: '#3e66e2' // 100% 处的颜色
      //             }
      //           ],
      //           global: false // 缺省为 false
      //         }
      //       }

      //     },
      //     {
      //       // name: "大豆政策保险",
      //       // data: [220, 182, 191, 234, 290, 330, 310, 182, 191, 234],
      //       type: 'line',
      //       smooth: true,
      //       stack: '总量',
      //       itemStyle: {},

      //       areaStyle: {
      //         color: {
      //           type: 'linear',
      //           x: 0,
      //           y: 0,
      //           x2: 0,
      //           y2: 1,
      //           colorStops: [
      //             {
      //               offset: 0,
      //               color: '#4ab2e9' // 0% 处的颜色
      //             },
      //             {
      //               offset: 1,
      //               color: '#4ab2e9' // 100% 处的颜色
      //             }
      //           ],
      //           global: false // 缺省为 false
      //         }
      //       }

      //     },
      //     {
      //       // name: "玉米政策保险",
      //       // data: [150, 232, 201, 154, 190, 330, 410, 190, 330, 410],
      //       type: 'line',
      //       smooth: true,
      //       stack: '总量',
      //       itemStyle: {

      //       },
      //       areaStyle: {
      //         color: {
      //           type: 'linear',
      //           x: 0,
      //           y: 0,
      //           x2: 0,
      //           y2: 1,
      //           colorStops: [
      //             {
      //               offset: 0,
      //               color: '#12d5d3' // 0% 处的颜色
      //             },
      //             {
      //               offset: 1,
      //               color: '#12d5d3' // 100% 处的颜色
      //             }
      //           ],
      //           global: false // 缺省为 false
      //         }
      //       }

      //     },
      //     {
      //       // name: "小麦政策保险",
      //       // data: [150, 232, 201, 154, 190, 330, 410, 190, 330, 410],
      //       type: 'line',
      //       smooth: true,
      //       stack: '总量',
      //       itemStyle: {
      //       },
      //       areaStyle: {
      //         color: {
      //           type: 'linear',
      //           x: 0,
      //           y: 0,
      //           x2: 0,
      //           y2: 1,
      //           colorStops: [
      //             {
      //               offset: 0,
      //               color: '#ff9023' // 0% 处的颜色
      //             },
      //             {
      //               offset: 1,
      //               color: '#ff9023' // 100% 处的颜色
      //             }
      //           ],
      //           global: false // 缺省为 false
      //         }
      //       }
      //     }
      //   ]

      // }
    }
  },
  mounted () {
    // this.initMap()

  },
  watch: {

  },
  methods: {
    listenResize () {
      // 窗口改变大小
      if (chart) {
        chart.resize()
      }
    },
    initMap (optionData) {
      // 设置时间
      if (optionData.date) {
        this.option.title.subtext = optionData.date || ''
      }
      this.option.dataset = optionData
      chart = echarts.init(
        document.getElementById(this.id)
      )
      chart.setOption(this.option)
    }

  },
  components: {

  }
}
</script>

<style scoped lang="less">
.o-echarts {
  min-width: 30px;
  min-height: 30px;
  width: 100%;
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/homechart/ProvinceInsuredChart.vue